<template lang="html">
  <section class="about">
    <h1 class="title"><span>About <em>us</em></span></h1>
    <h2 class="about__subtitle monitor monitorHide">{{ pageCopy.subtitle }}</h2>
    <p class="about__text monitor monitorHide">{{ pageCopy.text }}</p>

    <!-- logos -->
    <div class="about__partnerLogos">
      <PartnerLogo v-for="partner in partners" :name="partner.name" :logo="partner.logo" :url="partner.url" />
    </div>

    <div class="about__slider monitor monitorHide">
      <div class="about__slide" v-hammer:swipe="onSwipe" :style="{ backgroundImage: `url('${selectedImage}')` }"
        ref="slideElement"></div>
      <div class="about__sliderFooter">
        <ul class="about__dots">
          <li class="about__dot" :class="{ selected: i === selectedSlide }" v-for="(slide, i) in slides"
            @click="selectSlide" :key="i" :data-index="i"></li>
        </ul>
        <button class="about__next hover" @click="goToNext">next</button>
      </div>
    </div>
    <div class="about__leftContainer">
      <h1 class="title monitor monitorHide"><span v-html="pageCopy.leftContainerTitle"></span></h1>
      <template v-for="textItem in pageCopy.textItems">
        <h2 class="about__subtitle monitor monitorHide">{{ textItem.subtitle }}</h2>
        <p v-for="textPart in textItem.text.split('\n')" class="about__text monitor monitorHide">{{ textPart }}</p>
      </template>
    </div>
    <div class="about__rightContainer">
      <div v-for="icon in pageCopy.iconItems">
        <figure class="monitor monitorHide">
          <img :src="icon.icon" :alt="icon.text" />
        </figure>
        <p class="about__sideText monitor monitorHide">{{ icon.text }}</p>
      </div>
    </div>
    <div class="about__teamContainer">
      <h1 class="title"><span class="monitor monitorHide"><em>Our team</em></span></h1>
      <ul class="about__team">
        <TeamMember class="monitor monitorHide" v-for="member in teamMembers" :key="member.name" :name="member.name"
          :job="member.job" :image="member.image" />
      </ul>
    </div>
  </section>
</template>

<script>
import anime from "animejs";
import Lottie from "vue-lottie";
import * as arrowJson from "../assets/arrowJson.json";
import scrollMonitor from "scrollmonitor";
import TeamMember from "../components/TeamMember.vue";
import PartnerLogo from "../components/PartnerLogo.vue";

export default {
  name: "About",
  components: {
    TeamMember,
    Lottie,
    PartnerLogo
  },
  mounted() {
    setTimeout(() => {
      var elementList = document.querySelectorAll(".monitor");
      elementList.forEach(element => {
        var elementWatcher = scrollMonitor.create(element);
        elementWatcher.enterViewport(function () {
          element.classList.remove("monitorHide");
        });
        elementWatcher.exitViewport(function () {
          element.classList.add("monitorHide");
        });
      });
    }, 1000);
  },
  watch: {
    lang(newVal, oldVal) {
      setTimeout(() => {
        var elementList = document.querySelectorAll(".monitor");
        elementList.forEach(element => {
          var elementWatcher = scrollMonitor.create(element);
          elementWatcher.enterViewport(function () {
            element.classList.remove("monitorHide");
          });
          elementWatcher.exitViewport(function () {
            element.classList.add("monitorHide");
          });
        });
      }, 1000);
    }
  },
  data() {
    return {
      selectedSlide: 0,
      defaultOptions: {
        animationData: arrowJson,
        loop: false
      },
      animationSpeed: 1,
      anim1: null,
      anim2: null
    };
  },
  methods: {
    selectSlide(e) {
      const index = parseInt(e.target.dataset.index);
      this.goToSlide(index);
    },
    goToNext() {
      if (this.selectedSlide === this.slides.length - 1) return;
      this.goToSlide(this.selectedSlide + 1);
    },
    goToPrev() {
      if (this.selectedSlide === 0) return;
      this.goToSlide(this.selectedSlide - 1);
    },
    onSwipe(e) {
      if (e.direction === 2) this.goToNext();
      if (e.direction === 4) this.goToPrev();
    },
    goToSlide(slide) {
      this.$refs.slideElement.classList.add("translate");
      setTimeout(() => {
        this.selectedSlide = slide;
        this.$refs.slideElement.classList.remove("translate");
      }, 500);
    },
    handleAnimation1(anim) {
      this.anim1 = anim;
    },
    handleAnimation2(anim) {
      this.anim2 = anim;
    }
  },
  computed: {
    teamMembers() {
      return this.$store.state.teamMembers;
    },
    slides() {
      return this.pageCopy.imageSlider;
    },
    selectedImage() {
      return (
        this.pageCopy.imageSlider &&
        this.pageCopy.imageSlider[this.selectedSlide]
      );
    },
    pageCopy() {
      return this.$store.state.aboutusCopy;
    },
    partners() {
      return this.pageCopy.partners
    },
    config() {
      return this.$store.state.config;
    },
    lang() {
      return this.$store.state.lang;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/config.scss";

.about {
  max-width: 840px;
  font-size: 0;

  .title {
    margin-bottom: 60px;
  }

  .monitor {
    opacity: 1;
    transition: all 0.5s ease-out 0.3s;
  }

  .monitorHide {
    opacity: 0 !important;
    transform: translateY(80px) !important;
  }

  &__partnerLogos {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 24px;
  }

  &__slider {
    margin: 60px 0 100px;
    opacity: 0;
  }

  &__slide {
    height: 100%;
    height: 400px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 40px;
    opacity: 1;
    transition: opacity 0.5s ease-out, transform 0.4s ease-out;

    &.translate {
      transform: translateX(-20px);
      opacity: 0;
    }
  }

  &__sliderFooter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__dot {
    border-radius: 5px;
    border: 1px solid var(--Neu01);
    width: 6px;
    height: 6px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    transition: border-color 0.2s ease-in, width 0.3s ease-in;

    &.selected {
      border-color: var(--M01);
      width: 50px;
      transition: border-color 0.2s ease-in 0.3s,
        width 0.6s cubic-bezier(0.41, 0.15, 0.41, 1.31) 0.2s;
    }
  }

  &__next {
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    margin-left: 40px;
  }

  &__subtitle {
    font-family: CamptonBook;
    font-size: 28px;
    color: var(--Neu01);
    margin-top: 40px;
    margin-bottom: 30px;
    line-height: 1.35;
    opacity: 0;

    span {
      &.highlightHide:before {
        width: 0%;
      }

      &:before {
        content: "";
        position: absolute;
        bottom: 2px;
        height: 4px;
        width: 100%;
        transition: width 0.2s ease-out 1s;
        z-index: -1;
        background-color: var(--M01);
      }
    }
  }

  &__sideText {
    font-family: CamptonBold;
    font-size: 18px;
    color: var(--Neu01);
    margin-top: 20px;
    margin-bottom: 60px;
    line-height: 1.35;
  }

  &__text {
    font-family: CamptonBook;
    font-size: 20px;
    line-height: 1.35;
    color: var(--Neu01);
    opacity: 0;
    margin-bottom: 40px;
  }

  &__leftContainer {
    display: inline-block;
    vertical-align: top;
    width: 75%;

    h2,
    p {
      padding-right: 160px;
    }
  }

  &__rightContainer {
    display: inline-flex;
    vertical-align: top;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 25%;
    padding-left: 2%;

    figure {
      width: 60px;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }
  }

  &__teamContainer {
    margin-top: 60px;
    margin-bottom: 120px;
  }

  &__team {
    margin-top: 120px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 80px;
    grid-column-gap: 80px;
  }

  &__socialMedia {
    text-align: center;

    ul {
      margin-top: 20px;
    }
  }

  @include mq(0, 768px) {
    .title {
      margin-bottom: 40px;
    }

    &__subtitle {
      margin-top: 20px;
      margin-bottom: 10px;
    }

    &__partnerLogos {
      grid-template-columns: repeat(3, 1fr);
    }

    &__slider {
      margin: 40px 0;
    }

    &__next {
      margin-left: 40px;
    }

    &__leftContainer {
      width: 100%;

      h2,
      p {
        padding-right: 0;
      }
    }

    &__rightContainer {
      width: 100%;
    }

    &__sideText {
      margin-top: 10px;
      margin-bottom: 30px;
    }

    &__teamContainer {
      margin-top: 40px;
      margin-bottom: 60px;
    }

    &__team {
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 60px;
      grid-column-gap: 60px;
      margin-top: 60px;
    }
  }

  @include mq(0, 512px) {
    &__slide {
      height: 200px;
      margin-bottom: 20px;
    }

    &__team {
      grid-template-columns: repeat(1, 1fr);
      grid-row-gap: 60px;
      grid-column-gap: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/About.vue